import app from '@/lib/app';
import Image from 'next/image';
import Link from 'next/link';

const Brand = () => {
  return (
    <Link
      href="/teams"
      className="flex shrink-0 items-center text-lg font-bold gap-2 dark:text-gray-100 hover:opacity-80 transition-opacity"
    >
      <Image src={app.logoUrl} alt={app.name} width={42} height={42} />
      <span className="hidden sm:inline">{app.name}</span>
    </Link>
  );
};

export default Brand;
